import { api } from './fetch-json';

function sleep(ms: any) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Run query and returns results via batch API.
 * This is implemented to mimick the flow of the old `/query-results/` API,
 * where results were returned from that API call.
 * This function polls until the query is finished, and returns with the results.
 *
 * The returned data format is an array of objects,
 * instead of the array-of-array returned by the API.
 *
 * @param {Object} opt
 * @param {String} opt.batchText
 * @param {String} opt.connectionId
 * @param {String} [opt.selectedText]
 * @param {String} [opt.connectionClientId]
 * @param {String} [opt.queryId]
 * @param {String} [opt.name]
 * @param {Object} [opt.chart]
 */
export default async function runQueryViaBatch(opt: any) {
  if (!opt.connectionId) {
    return { error: 'Connection required' };
  }

  if (!opt.batchText) {
    return { error: 'SQL text required' };
  }

  if (!opt.selectedText) {
    opt.selectedText = opt.batchText;
  }

  let batch;
  let error;

  let res = await api.post('/api/batches', opt);
  error = res.error;
  batch = res.data;

  if (error) {
    return { error };
  }

  while (!(batch.status === 'finished' || batch.status === 'error') && !error) {
    await sleep(500);
    res = await api.get(`/api/batches/${batch.id}`);
    error = res.error;
    batch = res.data;
  }

  if (error) {
    return { error };
  }

  // This should not happen but just in case
  if (!batch.statements.length) {
    return { error: 'Statements not found' };
  }

  // For short-term API compat
  // Find out if a statement errored.
  // If it did, return that
  const statementWithError = batch.statements.find((s: any) => s.error);
  if (statementWithError) {
    return { error: statementWithError.error.title };
  }

  const statement = batch.statements[batch.statements.length - 1];

  res = await api.get(`/api/statements/${statement.id}/results`);
  if (res.error) {
    error = res.error;
  }

  if (error) {
    return { error };
  }

  const { columns } = statement;

  const rows = res.data.map((row: any) => {
    const obj = {};
    columns.forEach((c: any, index: any) => {
      // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      obj[c.name] = row[index];
    });
    return obj;
  });

  const links = {
    csv: `/statement-results/${statement.id}.csv`,
    json: `/statement-results/${statement.id}.json`,
    xlsx: `/statement-results/${statement.id}.xlsx`,
  };

  if (opt.queryId) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'table' does not exist on type '{ csv: st... Remove this comment to see the full error message
    links.table = `/query-table/${opt.queryId}`;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'chart' does not exist on type '{ csv: st... Remove this comment to see the full error message
    links.chart = `/query-chart/${opt.queryId}`;
    if (opt.connectionClientId) {
      const params = `?connectionClientId=${opt.connectionClientId}`;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'table' does not exist on type '{ csv: st... Remove this comment to see the full error message
      links.table += params;
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'chart' does not exist on type '{ csv: st... Remove this comment to see the full error message
      links.chart += params;
    }
  }

  return {
    data: {
      ...batch,
      batchId: batch.id,
      statementId: statement.id,
      columns,
      rows,
      incomplete: statement.incomplete,
      links,
      startTime: statement.startTime,
      stopTime: statement.stopTime,
      durationMs: statement.durationMs,
    },
    error,
  };
}
